import React from 'react';
import clsx from 'clsx';
import { Box, IconButton, Icons, Stack, Typography } from '@curves/ui-base';
import { Overview } from '@curves/ui-shared';

import { isValidDate, parseDate } from '@Util/moment.util';

import usePointsRewardsApi from "@Apis/usePointsRewardsApi";
const headerRow = [
    {
        cellKey: 'actionTypeText',
        headerLabel: '類型',
        align: 'left',
        width: 10,
        style: { minWidth: 50, maxWidth: '10rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
        formatCell: (value, { actionType }) => {
            return (actionType === 6
                    ? <Icons.ErrorOutline color={'error'} />
                    : <Typography component="span">{value}</Typography>
            );
        },
    },
    {
        cellKey: 'recordDate',
        headerLabel: '建立時間',
        align: 'center',
        width: 20,
        style: { minWidth: 50, maxWidth: '20rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
        formatCell: (value, { actionType }) => {
            return <Typography component="span">
                {isValidDate(value) && actionType !== 6
                    ? parseDate(value, 'YYYY/MM/DD HH:MM')
                    : '-'}
            </Typography>;
        },
    },
    {
        cellKey: 'points',
        headerLabel: '點數',
        align: 'center',
        width: 10,
        style: { minWidth: 50, maxWidth: '10rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
        formatCell: (value, { actionType }) => {
            return (
                actionType !== 6
                    ? <Typography className={clsx(value < 0 ? 'minus' : 'add', 'points-redeem-box', 'mx-auto')} component="div">
                        {value || 0}
                    </Typography>
                    : '-'
            );
        },
    },
    {
        cellKey: 'statusText',
        headerLabel: '狀態',
        width: 15,
        style: { minWidth: 50, maxWidth: '15rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
        align: 'center',
        formatCell: (value) => {
            return <Typography component="span">{value || ''}</Typography>;
        },
    },
    {
        cellKey: 'desc',
        headerLabel: '內容',
        align: 'left',
        style: { minWidth: 50 },
        formatCell: (value, { actionType, recordDate, combineRewardID }, { onCombineRewardChange }) => {
            return (
                <React.Fragment>
                    {actionType === 6 && <Typography>到期時間：{parseDate(recordDate, 'YYYY/MM/DD')}</Typography>}
                    {combineRewardID > 0
                        ? <Typography component="span"
                                      color="main"
                                      className="vertical-align-middle"
                                      onClick={() => onCombineRewardChange(combineRewardID, value)}>
                            {value || ''}
                        </Typography>
                        : <Typography component="span">
                            {value || ''}
                        </Typography>}
                </React.Fragment>);
        },
    },
    {
        cellKey: 'memo',
        headerLabel: '備註',
        align: 'left',
        style: { minWidth: 50 },
        formatCell: (value) => {
            return (<Typography component="span">{value}</Typography>);
        },
    },
];
const PointsRedeemRecordTable = React.forwardRef((props, ref) => {
    const { sourceData = {}, onPageChange, onCombineRewardChange } = props;
    const { deletePointRewardsRewardIDCacheApi } = usePointsRewardsApi();
    const { rewardID, pageSize = 10, pageIndex = 1, totalCount = 0, totalPage, list = [] } = sourceData || {};
    const handlePageChange = (num) => {
        if (document.activeElement) document.activeElement.blur();
        onPageChange && onPageChange(num);
    };
    const handleCacheClean = async () => {
        await deletePointRewardsRewardIDCacheApi(rewardID);
        setTimeout(() => {
            onPageChange && onPageChange(pageIndex);
        }, 100);
    };
    // 組出 Overview 所需的資料與換頁函式
    const contextValue = {
        overviewData: {
            list,
            pagination: { pageIndex, pageSize, totalCount, totalPage: totalPage ?? 0 },
        },
        updateOverviewPage: handlePageChange,
    };
    return (
        <Box className="mt-4">
            <Overview contextValue={contextValue}>
                <Stack className="overview__toolbar" alignItems="center" justifyContent="end">
                    <Overview.TotalCount showRange />
                    <IconButton onClick={handleCacheClean}>
                        <Icons.Refresh />
                    </IconButton>
                </Stack>
                <Overview.Table
                    headerRow={headerRow}
                    cardProps={{ className: 'theme-gray' }}
                    cellRenderContext={{ onCombineRewardChange }}
                />
                <Overview.Pagination className="mt-4" />
            </Overview>
        </Box>
    );
});
export default PointsRedeemRecordTable;
